import { _ as T } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { _ as f } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.object.assign-7e79fd7b.js";
import { c as s } from "./index-8b07dec9.js";
import { createContext as z, forwardRef as $, useContext as B, useRef as Q } from "react";
import U, { css as m, styled as N } from "styled-components";
import "./es.object.keys-9d66766f.js";
import { QUERIES as k } from "@ucl/shared-component-foundations";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import { useScroll as q } from "./useScroll.js";
import { useSlots as R } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { c as D } from "./combineRefs-c9ad2c39.js";
import { jsx as a, jsxs as H } from "react/jsx-runtime";
import { useMediaQuery as X } from "./useMediaQuery.js";
import { IconButton as w } from "./iconButton.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./getMetrics-953aa4f8.js";
import "./button.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
var p = /* @__PURE__ */ z(null), J = /* @__PURE__ */ U.div.withConfig({
  displayName: "carouselcontents__StyledCarouselContent",
  componentId: "sc-13hu3vj-0"
})(["&.Carousel__content{", ";}"], function(o) {
  var t = o.theme.components.carousel;
  return m(t.CarouselContent);
}), K = /* @__PURE__ */ $(function(o, t) {
  var r = B(p);
  return /* @__PURE__ */ a(J, Object.assign({}, o, {
    ref: D(t, r),
    className: s(["Carousel__content", o.className])
  }));
}), A = function(t) {
  var r = B(p), n = X(k.mobile), l = function(i) {
    t.onClick == null || t.onClick(i), r != null && r.current && (r.current.scrollLeft -= n ? r.current.clientWidth : r.current.clientWidth / 2);
  };
  return /* @__PURE__ */ a(w, Object.assign({}, t, {
    color: "onColor",
    icon: "caretLeft",
    size: "extra-small",
    className: s(["CarouselPrevButton", t.className]),
    onClick: l
  }));
}, W = function(t) {
  var r = B(p), n = X(k.mobile), l = function(i) {
    t.onClick == null || t.onClick(i), r != null && r.current && (r.current.scrollLeft += n ? r.current.clientWidth : r.current.clientWidth / 2);
  };
  return /* @__PURE__ */ a(w, Object.assign({}, t, {
    color: "onColor",
    icon: "caretRight",
    size: "extra-small",
    className: s(["CarouselNextButton", t.className]),
    onClick: l
  }));
}, V = ["hideOverFlowGradient", "hideControls", "centered"], O, L, y, Y = N.div(O || (O = f([`
  &.Carousel {
    `, `;
  }
`])), function(o) {
  var t = o.theme.components.carousel;
  return m(t.Carousel);
}), Z = N(A)(L || (L = f([`
  &.PreviousButton {
    `, `;
  }
`])), function(o) {
  var t = o.theme.components.carousel;
  return m(t.PreviousButton);
}), tt = N(W)(y || (y = f([`
  &.NextButton {
    `, `;
  }
`])), function(o) {
  var t = o.theme.components.carousel;
  return m(t.NextButton);
}), u = /* @__PURE__ */ $(function(o, t) {
  var r, n, l, c, i, h, x = o.hideOverFlowGradient, _ = o.hideControls, P = _ === void 0 ? !1 : _, S = o.centered, E = S === void 0 ? !1 : S, v = T(o, V), d = Q(null), C = q(d == null ? void 0 : d.current), b = C.isScrollableX, F = C.isScrollXAtEnd, G = C.isScrollXAtStart, e = R(v.children, {
    Content: u.Content,
    PrevButton: u.PrevButton,
    NextButton: u.NextButton
  }, R.PickType.LAST), I = /* @__PURE__ */ a(Z, Object.assign({}, (r = e.PrevButton) == null ? void 0 : r.props, {
    className: s(["PreviousButton", (n = e.PrevButton) == null ? void 0 : n.props.className])
  })), M = /* @__PURE__ */ a(tt, Object.assign({}, (l = e.NextButton) == null ? void 0 : l.props, {
    className: s(["NextButton", (c = e.NextButton) == null ? void 0 : c.props.className])
  })), g = b && !G, j = b && !F;
  return /* @__PURE__ */ a(p.Provider, {
    value: d,
    children: /* @__PURE__ */ H(Y, Object.assign({
      ref: t
    }, v, {
      className: s(["Carousel", {
        "Carousel--left": !x && g,
        "Carousel--right": !x && j,
        "Carousel--centered": E
      }, v.className]),
      children: [(!P || !!((i = e.PrevButton) != null && i.props)) && g && I, e == null ? void 0 : e.Content, " ", e == null ? void 0 : e.rest, (!P || !!((h = e.NextButton) != null && h.props)) && j && M]
    }))
  });
});
u.PrevButton = A;
u.NextButton = W;
u.Content = K;
export {
  u as Carousel
};
